import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import styles from "./allAssessments.module.css";

const fetchCompanyData = async () => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  const raw = JSON.stringify({ "useremail": "" });
  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  };
  try {
    const response = await fetch("https://casaahaanahotels.com/search_company_data", requestOptions);
    return await response.json();
  } catch (error) {
    console.error("Error fetching company data:", error);
    return [];
  }
};

const fetchDepartmentData = async () => {
  try {
    const response = await axios.post("https://casaahaanahotels.com/get_master_assessment_type", {});
    return response.data;
  } catch (error) {
    console.error("Error fetching department data:", error);
    return [];
  }
};

const ViewScore = () => {
  const [assessments, setAssessments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [companies, setCompanies] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [selectedCompanyCode, setSelectedCompanyCode] = useState("");
  const [selectedDepartmentCode, setSelectedDepartmentCode] = useState("");
  const [searchUserEmail, setSearchUserEmail] = useState("");

  const navigate = useNavigate();

  // Load assessments with filters
  const loadAssessments = async (filters) => {
    setLoading(true);
    try {
      const response = await axios.post(
        "https://casaahaanahotels.com/list_assessments",
        filters,
        { headers: { "Content-Type": "application/json" } }
      );
      if (response.data && response.data.result) {
        setAssessments(response.data.result);
      } else {
        setError("No assessments found.");
      }
    } catch (err) {
      console.error("Error fetching assessments:", err);
      setError("Failed to fetch assessments.");
    } finally {
      setLoading(false);
    }
  };

  // On mount, load all assessments (with empty filters)
  useEffect(() => {
    loadAssessments({
      useremail: "",
      companycode: "",
      departmentcode: ""
    });
  }, []);

  // Fetch company data
  useEffect(() => {
    let isMounted = true;
    const loadCompanies = async () => {
      const data = await fetchCompanyData();
      if (isMounted) {
        setCompanies(data);
      }
    };
    loadCompanies();
    return () => { isMounted = false; };
  }, []);

  // Fetch department data
  useEffect(() => {
    let isMounted = true;
    const loadDepartments = async () => {
      const data = await fetchDepartmentData();
      if (isMounted) {
        setDepartments(data);
      }
    };
    loadDepartments();
    return () => { isMounted = false; };
  }, []);

  // Handle search button click: call API with selected filters
  const handleSearch = () => {
    loadAssessments({
      useremail: searchUserEmail.trim(),
      companycode: selectedCompanyCode,
      departmentcode: selectedDepartmentCode
    });
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Assessment List</h2>
      
      <div className={styles.filterContainer}>
        {/* Company dropdown */}
        <select 
          className={styles.companyDropdown} 
          value={selectedCompanyCode}
          onChange={(e) => setSelectedCompanyCode(e.target.value)}
        >
          <option value="">All Companies</option>
          {companies.map((company) => (
            <option key={company.id} value={company.admincode}>
              {company.companyname}
            </option>
          ))}
        </select>
        
        {/* Department dropdown */}
        <select 
          className={styles.departmentDropdown}
          value={selectedDepartmentCode}
          onChange={(e) => setSelectedDepartmentCode(e.target.value)}
        >
          <option value="">All Departments</option>
          {departments.map((dept) => (
            <option key={dept.assessment_type_id} value={dept.assessment_type_id}>
              {dept.AssessmentType}
            </option>
          ))}
        </select>
        
        {/* User email search input */}
        <input
          type="text"
          placeholder="Search by User Email..."
          value={searchUserEmail}
          onChange={(e) => setSearchUserEmail(e.target.value)}
          className={styles.searchInput}
        />
        
        {/* Search button */}
        <button onClick={handleSearch} className={styles.searchButton}>
          Search
        </button>
      </div>

      {loading ? (
        <p className={styles.loadingText}>Loading...</p>
      ) : error ? (
        <p className={styles.errorText}>{error}</p>
      ) : (
        <div className={styles.tableWrapper}>
          <table className={styles.assessmentTable}>
            <thead>
              <tr>
                <th>Driver Name</th>
                <th>Email</th>
                <th>Company Name</th>
                <th>Star Score</th>
                <th>Completed Date</th>
                <th>Validity</th>
                <th>View</th>
              </tr>
            </thead>
            <tbody>
              {assessments.map((assessment, idx) => {
                if (assessment?.driverid && assessment?.score) {
                  const firstName = assessment?.driver_details?.FirstName || "N/A";
                  const lastName = assessment?.driver_details?.LastName || "N/A";
                  const driverName = `${firstName} ${lastName}`;
                  const driverEmail = assessment?.driver_details?.DriverEmail || "N/A";
                  const companyName = assessment?.company_details?.companyname || "N/A";
                  const starScore = assessment?.score || 0;
                  const completedDate = new Date(assessment.timestamp).toLocaleDateString("en-US");
                  const validityDate = new Date(assessment.validity).toLocaleDateString("en-US");
                  const assessmentId = assessment.assessementid;
                  return (
                    <tr key={idx}>
                      <td>{driverName}</td>
                      <td>{driverEmail}</td>
                      <td>{companyName}</td>
                      <td>
                        <img
                          src={`https://starbehaviors.com/uploadimage/${starScore}.png`}
                          alt={`Score: ${starScore}`}
                          className={styles.scoreImage}
                        />
                      </td>
                      <td>{completedDate}</td>
                      <td>{validityDate}</td>
                      <td>
                        <button
                          className={styles.viewButton}
                          onClick={() => navigate(`/admin/search-assessments/${assessmentId}`)}
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  );
                }
                return null;
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ViewScore;
